<template>
	<div>
		<erji-title :titleName="this.titleName" :fatherName="this.fatherName"></erji-title>
		<div class="erji-content">
			<div class="danpian-con-wp">
				<div class="danpian-con">
					<img :src="icoURL+'storage/'+this.erimg" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'contentt',
		data(){
			return{
				titleName:'',
				fatherName:'',
				childId:'',
				content:'',
				setting:[],
				erimg:''
			}
		},
		methods:{
			res_menusClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
								this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求父类信息
			res_fatherClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// console.log('response090',response)
								this.fatherName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求站点信息二维码
			res_siteInfo(){
				this.axios.get('/api/setting')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
								this.setting = response.data.reslut;
								console.log(response)
								this.setting.forEach(item=>{
									if(item.key == "default.wechat" && this.$route.query.category_id == 50){
										this.erimg = item.value;
										console.log('001')
									}else if(item.key == "default.mobile_web" && this.$route.query.category_id == 51){
										this.erimg = item.value;
										console.log('002')
									}
								})
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			
		},
		created() {
			console.log('this.$routethis.$route',this.$route)
			this.childId = this.$route.query.category_id;
			this.res_menusClass(this.childId);
			this.res_fatherClass(this.$route.params.id)
			this.res_siteInfo();
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					console.log('curIDfrom',from)
					this.childId = to.query.category_id;
					this.res_menusClass(this.childId)
					this.res_siteInfo();
			}
		},
		mounted(){
			
		}
	}
</script>

<style>
</style>